var version = {
    "name":      "dativery",
    "buildDateCode": "20251209-203833",
    "buildDate": "Tue Dec 09 2025 20:38:33 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251209-203833",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;